<tt-grid *ngIf="!!grid" [(ttOptions)]="grid" (ttReady)="gridReady.emit(grid)"></tt-grid>
